import { ISmartMeterSummary } from "./smartMeterSummary.types"
export class SmartMeterSummary implements ISmartMeterSummary {
  constructor(
    public working: number,
    public uncommissioned: number,
    public inherited: number,
    public inlifeissue: number,
    public criticalalert: number,
    public firmwareexpired: number,
    public total: number,
  ) {}
}
